import ProductCatalogSection from "./ProductCatalogSection";

export { ProductCatalogSection as default };
